<template>
	<div class="confirm-form">
		<Loader :show="saving"></Loader>
		
		<h5>Confirmar fecha de entrega</h5>
		<p class="mt-2 mb-4">
			Ingrese y confirme la fecha a entregar el vehículo
		</p>
		<b-form inline>
			<date-picker 
				v-model="form.delivery_scheduled_date" 
				:class="{'is-invalid':validation.hasError('form.delivery_scheduled_date')}"
				type="datetime"
				value-type="YYYY-MM-DD HH:mm:00" 
				format="DD-MM-YYYY HH:mm"
				:minute-step="30"
				:hour-options="Array.from({ length: 12 }).map((_, i) => i + 8)"
				:disabled-date="disabledPeriodDate"
			></date-picker>	
			<b-button variant="success" size="sm" class="ml-2" @click="save()">Confirmar fecha</b-button>
		</b-form>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;
import Loader from '@/components/Loader'

export default {
	name: "CarConfirmDeliveryForm",
	components:{
		Loader
	},
	mixins:[mixins],
	props:{
		carId:{
			type: String
		},
	},
	data () {
		return {
			saving: false,
			form: {
				delivery_scheduled_date: null,
			},
		}
	},
	validators: {
		'form.delivery_scheduled_date': function (value) {
			return Validator.value(value).required();
		},
	},
	methods:{
		disabledPeriodDate(date) {
			var yesterday = new Date()
			yesterday.setDate(yesterday.getDate())
			return date < yesterday
		},
		async save () {
			if(!this.saving && await this.checkValidation() ) {
				this.saving = true

				let dataInput = {
					car_id 						: this.carId,
					delivery_scheduled_date		: this.form.delivery_scheduled_date
				}
				this.$apollo.mutate({
					mutation: gql`mutation ( $data:RequestConfirmDeliveryInput! ){
						requestConfirmDelivery( data: $data) {
							id
							delivery_scheduled_at
						}
					}`,
					variables: {
						data: dataInput
					}
				})
				.then((data) => {
					this.chargeCreated = data.data.requestConfirmDelivery
					this.saving = false
					this.$emit('changed')
				})
				.catch( (error) => {
					this.errors = this.parseGQLErrors(error)
					this.$toast.error('Error!')
					this.saving = false
				})
			}
		},
	}
}
</script>

<style lang="scss" scoped>

</style>